import { EntityType } from 'common/types';

export type Paginated = {
  pagination?: { next: string | null; previous?: string | null };
};
export type SortOrder = 'ASC' | 'DESC';

export type InsightGenericData = {
  id: string;
  type: EntityType;
  startDate: string;
  endDate: string;
};

export type MonetaryInsight = {
  currency: Currency;
};

export type SalesInsight = {
  /** @deprecated use {@link import('./utils').getSales} instead of reading value directly */
  salesWithVat: number;
  /** @deprecated use {@link import('./utils').getSales} instead of reading value directly */
  salesNoVat: number;
};

export type OrdersInsight = {
  orders: number;
};

export type AvgBasketSizeInsight = {
  avgBasketSizeItems: number;
  /** @deprecated use {@link import('./utils').getBasketSize} instead of direct use */
  avgBasketSizeWithVat: number;
  /** @deprecated use {@link import('./utils').getBasketSize} instead of direct use */
  avgBasketSizeNoVat: number;
};

export type UnitsInsight = {
  units: number;
};

export enum RejectionsCategoriesLabels {
  MINUTE_REJECTION_15 = '15_minute_rejection',
  MINUTE_REJECTION_3 = '3_minute_rejection',
  ACCIDENTAL_PREORDER = 'accidental_preorder',
  ACCIDENTAL_TAKEAWAY = 'accidental_takeaway',
  CLOSING_SOON = 'closing_soon',
  CUSTOMER_CANCEL_ON_ORDER_PREVIEW = 'customer_cancel_on_order_preview',
  CUSTOMER_CANCEL_ON_ORDER_REVIEW = 'customer_cancel_on_order_review',
  CUSTOMER_NOT_HAPPY_WITH_ETA = 'customer_not_happy_with_eta',
  GENERIC_CUSTOMER_REQUESTED = 'generic_customer_requested',
  GENERIC_REJECTION = 'generic_rejection',
  GENERIC_VENUE_REQUESTED = 'generic_venue_requested',
  ITEM_UNAVAILABLE = 'item_unavailable',
  NO_COURIERS_AVAILABLE = 'no_couriers_available',
  ORDER_CANNOT_BE_DELIVERED = 'order_cannot_be_delivered',
  CUSTOMER = 'customer',
  VENUE_TOO_BUSY = 'venue_too_busy',
}
